import { Pipe, PipeTransform } from '@angular/core';
import { Classification } from '@interfaces/Classification';

@Pipe({
  name: 'classDescription'
})
export class ClassDescriptionPipe implements PipeTransform {
  public transform(classification: Classification, currentLang: string): string {
    let description = '';

    if (currentLang === 'en') {
      description = classification?.description2 || classification?.description;
    } else if (currentLang === 'fr') {
      description = classification?.description;
    }

    return description;
  }
}
